import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import ConfirmPopup from './ConfirmPopup';
import AddPriceListTier from './AdminPriceListsAddTierModal';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';

interface PriceListTierList {
    id: number;
    uniqueId: string;   //to cater for customer and tier pricelists
    name: string;
    typeId: number;
}

interface Item {
    id: number;
    name: string;
    defaultDays: number;
    typeId: number;
    overhireRequired: boolean;
}

interface GenericList {
    id: number;
    name: string;
}

interface PriceListItem {
    id: number;
    tierId: number;
    customerId: number;
    itemId: number;
    item: string;
    itemTypeId: number;
    frequencyId: number;
    oneWeek: number;
    sixWeek: number;
    tenWeek: number;
    thirteenWeek: number;
    fourteenWeek: number;
    twentyWeek: number;
    twentySixWeek: number;
    fortyWeek: number;
    fiftyTwoWeek: number;
    additionalHireWeeklyRate: number;
    travelOneWayRate: number;
    statusId: number;
    isDirty: boolean;
}

interface TierDiscount {
    name: string;
    startDays: number;
    endDays: number;
    discountPercent: number;
}

const AdminPriceListSetWeeksData = (props: RouteComponentProps<{}>) => {
    const [loading, setLoading] = React.useState(true);
    const [pricelistLoading, setPricelistLoading] = React.useState(false);
    const [priceListTiers, setPriceListTiers] = React.useState<PriceListTierList[]>([]);
    const [priceListTier, setPriceListTier] = React.useState({ priceListUniqueId: "", priceListTierId: -1, priceListTierType: -1 });
    const [customerOptions, setCustomerOptions] = React.useState<GenericList[]>([]);
    const [itemList, setItemList] = React.useState<Item[]>([]);
    const [frequencyList, setFrequencyList] = React.useState<GenericList[]>([]);
    const [priceListItems, setPriceListItems] = React.useState<PriceListItem[]>([]);
    const [useOverhireRate, setUseOverhireRate] = React.useState(true);
    const [errors, setErrors] = React.useState<{ [key: string]: string }>({});
    const [showDeleteConfirm, setShowDeleteConfirm] = React.useState(false);
    const [deleteIndex, setDeleteIndex] = React.useState(-1);
    const [showAddTier, setShowAddTier] = React.useState(false);
    const [tierName, setTierName] = React.useState("");
    const [tierCustomerId, setTierCustomerId] = React.useState(-1);
    const [readOnly, setReadOnly] = React.useState(false);

    React.useEffect(() => {
        window.scrollTo(0, 0);

        getData();
    }, []);

    const getData = async () => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/User/CheckUserPermission?Permission=AdminPricelistsView&SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data == true) {
                getPriceListData();
            } else if (res.data == false) {
                //redirect to 403 permission denied
                props.history.push("/accessdenied")
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }


    const getPriceListData = async () => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/PriceList/GetPricelistData?SubId=' + user.sub + '&IsEws=false&IsPumpClean=false&IsEpa=false&IsFencing=false&IsEvent=false', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            setItemList(res.data.itemList);
            var frequency: GenericList[] = res.data.frequencyList;
            frequency = frequency.filter(f => f.id < 4);
            setFrequencyList(frequency);
            setPriceListTiers(res.data.priceListTier);
            setCustomerOptions(res.data.customerOptions);
            setReadOnly(res.data.readOnly);
            setLoading(false);
        }).catch(error => {
            toast.error(error.message);
        });
    }

    const getPricelist = async (id: number, typeId: number) => {
        if (id > 0) {
            setPricelistLoading(true);
            const token = await authService.getAccessToken();
            const user = await authService.getUser();
            axios.get('api/PriceList/GetPricelistSetWeeks?SubId=' + user.sub + '&Id=' + id + '&PriceListType=' + typeId, {
                headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
            })
            .then(res => {
                var pricelist = res.data.priceList;
                let pricelistItem = addBlankRow(id, typeId * 1);
                pricelist.push(pricelistItem);

                setPriceListItems(pricelist);
                setUseOverhireRate(res.data.useOverhireRate);
                setPricelistLoading(false);
            })
            .catch(error => {
                setPricelistLoading(false);
                toast.error(error.message);
            });
        } else {
            setPriceListItems([]);
            setPricelistLoading(false);
        }
    }

    const addBlankRow = (id: number, typeId: number) => {
        var tierId = -1;
        var customerId = -1;
        if (typeId === 1) {
            tierId = id;
        } else {
            customerId = id;
        }

        let pricelistItem: PriceListItem = {
            id: 0,
            tierId: tierId,
            customerId: customerId,
            itemId: -1,
            item: "",
            itemTypeId: -1,
            frequencyId: -1,
            oneWeek: 0,
            sixWeek: 0,
            tenWeek: 0,
            thirteenWeek: 0,
            fourteenWeek: 0,
            twentyWeek: 0,
            twentySixWeek: 0,
            fortyWeek: 0,
            fiftyTwoWeek: 0,
            additionalHireWeeklyRate: 0,
            travelOneWayRate: 0,
            statusId: 1,
            isDirty: false
        };

        return pricelistItem;
    }

    const handlePriceListChange = (e: any) => {
        var uniqueId = e.target.value;
        var plId = uniqueId.substring(1) * 1;
        let typeId = 1;

        if (uniqueId != "") {
            let priceListOption = priceListTiers[e.target.selectedIndex - 1];
            if (priceListOption) {
                typeId = priceListOption.typeId;
            }
        }

        setPriceListTier({ priceListUniqueId: uniqueId, priceListTierId: plId, priceListTierType: typeId });

        if (uniqueId != "") {
            getPricelist(plId, typeId);
        } 
    }

    const handleCellChange = (e: any, itemIndex: number) => {
        let error = errors;
        delete error["pricelistitems"];

        var newValue = e.target.value * 1;
        let plItems = [...priceListItems];
        let plItem = plItems[itemIndex];

        let updatedPlItem: any = {};
        updatedPlItem = plItem;
        updatedPlItem[e.target.name] = newValue;
        updatedPlItem["isDirty"] = true;

        if (e.target.name === "itemId") {
            //get item type id
            var item = itemList.find(i => i.id === newValue);
            if (item) {
                updatedPlItem["itemTypeId"] = item.typeId;
                updatedPlItem["item"] = item.name;
            }
        }

        if (itemIndex == (priceListItems.length - 1)) {
            //add new row
            var newRow = addBlankRow(priceListTier.priceListTierId, priceListTier.priceListTierType);
            plItems.push(newRow);
        }

        setPriceListItems(plItems);
    }

    //ADD TIER
    const addTier = () => {
        setTierName("");
        setTierCustomerId(-1);
        setShowAddTier(true);
    }

    const hideAddTier = () => {
        setTierName("");
        setTierCustomerId(-1);
        setShowAddTier(false);
    }

    const updateTierName = (tier: string) => {
        setTierName(tier);
    }

    const updateCustomer = (customerId: number) => {
        setTierCustomerId(customerId);
    }

    const updateTierDiscount = (tierDiscount: TierDiscount[]) => {
        //not used for Set Weeks Pricelists
    }

    const handleUseOverhireRateCheckboxChange = (e: any) => {
        updateUseOverhireRate(e.target.checked);
    }

    const updateUseOverhireRate = async (useOverhireRate: boolean) => {
        const token = await authService.getAccessToken();

        var saveUseOverhire = {
            id: priceListTier.priceListTierId,
            typeId: priceListTier.priceListTierType,
            useOverhireRate: useOverhireRate
        };

        axios.post('api/PriceList/SaveTierUseOverhireRate', saveUseOverhire, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data.isError) {
                var errors = res.data.messages as any[];
                for (var i = 0; i < errors.length; i++) {
                    toast.error(errors[i].content);
                };
            } else {
                toast.success("Use Overhire Rate Saved Successfully");
                setUseOverhireRate(useOverhireRate);
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }
    
    const saveAddTier = (typeId: number) => {
        saveAddNewTier(typeId);
    }

    const saveAddNewTier = async (typeId: number) => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        let pricelistTiers = [...priceListTiers];

        if (typeId === 1) {
            let saveAddTier = {
                tierName: tierName,
                discounts: [],
                subId: user.sub
            };

            axios.post('api/PriceList/SavePriceListTier', saveAddTier, {
                headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
            })
            .then(res => {
                if (res.data.isError) {
                    var errors = res.data.messages as any[];
                    for (var i = 0; i < errors.length; i++) {
                        toast.error(errors[i].content);
                    };
                } else {
                    pricelistTiers.push(res.data);
                    toast.success("Price List Tier Saved Successfully");

                    let pricelist: PriceListItem[] = [];
                    let pricelistItem = addBlankRow(res.data.id, 1);
                    pricelist.push(pricelistItem);

                    setPriceListTier({ priceListTierId: res.data.id, priceListTierType: 1, priceListUniqueId: res.data.uniqueId });
                    setPriceListItems(pricelist);
                    setPriceListTiers(pricelistTiers);
                    setTierName("");
                    setTierCustomerId(-1);
                    setUseOverhireRate(true);
                    setShowAddTier(false);
                }
            })
            .catch(error => {
                toast.error(error.message);
            });
        } else {
            var customerId = tierCustomerId * 1;
            var customer = customerOptions.find(c => c.id === customerId);
            let saveAddTier = {
                customerid: customerId,
                customerName: customer?.name,
                isEws: false,
                discounts: [],
                subId: user.sub
            };

            axios.post('api/PriceList/SavePricelistCustom', saveAddTier, {
                headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
            })
            .then(res => {
                if (res.data.isError) {
                    var errors = res.data.messages as any[];
                    for (var i = 0; i < errors.length; i++) {
                        toast.error(errors[i].content);
                    };
                } else {
                    pricelistTiers.push(res.data);
                    toast.success("Price List Custom Saved Successfully");

                    let pricelist: PriceListItem[] = [];
                    let pricelistItem = addBlankRow(res.data.id, 2);
                    pricelist.push(pricelistItem);

                    setPriceListTier({ priceListTierId: res.data.id, priceListTierType: 2, priceListUniqueId: res.data.uniqueId });
                    setPriceListItems(pricelist);
                    setPriceListTiers(pricelistTiers);
                    setTierName("");
                    setTierCustomerId(-1);
                    setUseOverhireRate(true);
                    setShowAddTier(false);
                }
            })
            .catch(error => {
                toast.error(error.message);
            });
        }
    }

    //END ADD TIER

    //DELETE PRICELIST ITEM
    const deleteItem = (e: any, itemIndex: number) => {
        e.preventDefault();

        setShowDeleteConfirm(true);
        setDeleteIndex(itemIndex);
    }

    const hideDeleteConfirm = () => {
        setShowDeleteConfirm(false);
        setDeleteIndex(-1);
    }

    const saveDeleteConfirm = () => {
        var pricelist = [...priceListItems];
        var pricelistItem = pricelist[deleteIndex];

        if (pricelistItem.id === 0) {
            //just remove from the list as not saved
            pricelist.splice(deleteIndex, 1);
            setShowDeleteConfirm(false);
            setDeleteIndex(-1);
            setPriceListItems(pricelist);

            toast.success("Item deleted successfully");
        } else {
            saveDeletePricelist(pricelist, pricelistItem.id);
        }
    }

    const saveDeletePricelist = async (pricelist: PriceListItem[], pricelistItemId: number) => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var deletePriceList = {
            id: pricelistItemId,
            subId: user.sub
        };

        axios.post('api/PriceList/DeletePricelistSetWeeksItem', deletePriceList, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data.isError) {
                var errors = res.data.messages as any[];
                for (var i = 0; i < errors.length; i++) {
                    toast.error(errors[i].content);
                };
            } else {
                toast.success("Price List Saved Successfully");
                pricelist.splice(deleteIndex, 1);
                setShowDeleteConfirm(false);
                setDeleteIndex(-1);
                setPriceListItems(pricelist);
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }
    //END DELETE PRICELIST ITEM

    const validate = () => {
        let errorList: any = {};
        let formIsValid = true;
        let items = priceListItems;

        if (priceListItems.length === 1) {
            errorList["pricelistitems"] = "Please enter at least one item!";
            setErrors(errorList)
            return true;
        }

        var rowNumber = 0;
        var errorString = "Please enter the following values: ";
        var error = false;

        for (var i = 0; i < items.length - 1; i++) {
            rowNumber += 1;
            var newErrorString = "";

            if (items[i].itemId < 1) {
                newErrorString += "Item, ";
                error = true;
            }

            //must have at least one price entered
            var checkPrices = items[i].oneWeek + items[i].sixWeek + items[i].tenWeek + items[i].thirteenWeek + items[i].fourteenWeek + items[i].twentyWeek + items[i].twentySixWeek + items[i].fortyWeek + items[i].fiftyTwoWeek; 
            if (checkPrices <= 0) {
                newErrorString += "At least one weekly rate price(1, 6, 10, 13, 14, 20, 26, 40 or 52), ";
                error = true;
            }

            if (!items[i].additionalHireWeeklyRate || items[i].additionalHireWeeklyRate <= 0) {
                newErrorString += "Additional Hire Rate, ";
                error = true;
            }

            if (newErrorString != "") {
                errorString += "\n"
                errorString += "Row " + rowNumber + ": " + newErrorString;
                errorString = errorString.substring(0, errorString.length - 2);
            }

        }
        if (error) {
            formIsValid = false;
            errorList["pricelistitems"] = errorString;
        }
        setErrors(errorList);
        return formIsValid;
    }

    const save = (e: any) => {
        e.preventDefault();

        if (validate()) {
            var changed = priceListItems.filter(p => p.isDirty);

            if (changed.length === 0) {
                toast.info("No items have changed.");
            } else {
                savePricelist(changed);
            }
        } else {
            toast.error("Please fix validation errors before Saving")
        }
    }

    const savePricelist = async (changed: PriceListItem[]) => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var savePriceList = {
            priceListItems: changed,
            subId: user.sub
        };

        axios.post('api/PriceList/SavePriceListSetWeeks', savePriceList, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data.isError) {
                var errors = res.data.messages as any[];
                for (var i = 0; i < errors.length; i++) {
                    toast.error(errors[i].content);
                };
            } else {
                toast.success("Price List Saved Successfully");
                setPricelistLoading(true);
                getPricelist(priceListTier.priceListTierId, priceListTier.priceListTierType);
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    const addNewTier = <AddPriceListTier showModal={showAddTier} tierName={tierName} customerId={tierCustomerId} tierDiscount={[]} customerOptions={customerOptions} systemCompanyId={3} hideModal={hideAddTier} updateTier={updateTierName} updateCustomer={updateCustomer} updateTierDiscount={updateTierDiscount} saveModal={saveAddTier} />
    const lastRow = priceListItems.length - 1;
    const confirmPopup = <ConfirmPopup heading="Delete Price List Item?" text="Are you sure you want to delete this price list item?" hideConfirmModal={hideDeleteConfirm} showConfirmModal={showDeleteConfirm} saveConfirmModal={saveDeleteConfirm} />

    const renderDetails = (
        <div>
            <div className="static-modal">
                {confirmPopup}
                {addNewTier}
            </div>
            <div className="input-group-parent">
                <label className="input-group" htmlFor="priceListTierId">
                    <span className="label">Tier/Customer</span>
                    <select className="select marginRight10" id="priceListUniqueId" name="priceListUniqueId" value={priceListTier.priceListUniqueId} onChange={(e) => handlePriceListChange(e)}>
                        <option hidden defaultValue=""></option>
                        {priceListTiers.map(tier =>
                            <option key={tier.uniqueId} value={tier.uniqueId}>{tier.name}</option>
                        )};
                    </select>
                    <button className={readOnly ? "hidden" : "defaultbutton defaultbutton__small"} type="button" onClick={addTier}>Add New</button>
                </label>
            </div>
            <div className={priceListTier.priceListTierId > 0 && priceListTier.priceListTierType === 1 ? "input-group-parent" : "hidden"}>
                <label className="input-group" htmlFor="useOverhireRate">
                    <span className="label label-large label--nopadding">Use Pricelist Overhire Rate for Invoices</span>
                    <input className="checkbox" type="checkbox" id="useOverhireRate" name="useOverhireRate" checked={useOverhireRate} onChange={(e) => handleUseOverhireRateCheckboxChange(e)} disabled></input>
                </label>
            </div>

            <div>
                <hr></hr>
            </div>
            <div className={priceListTier.priceListTierId > 0 && !pricelistLoading ? "" : "hidden"}>
                <div className="overflowAuto">
                    <table className="table tableColours">
                        <thead>
                            <tr>
                                <th className="hidden">Id</th>
                                <th></th>
                                <th>Item</th>
                                <th>Maintenance</th>
                                <th>1 Week</th>
                                <th>6 Weeks</th>
                                <th>10 Weeks</th>
                                <th>13 Weeks</th>
                                <th>14 Weeks</th>
                                <th>20 Weeks</th>
                                <th>26 Weeks</th>
                                <th>40 Weeks</th>
                                <th>52 Weeks</th>
                                <th>Additional Weekly Rate</th>
                                <th>Travel One Way</th>
                                <th></th>
                            </tr>
                        </thead>
                        {priceListItems.map((item, index) =>
                            <tbody key={index}>
                                <tr>
                                    <td className="hidden">{item.id}</td>
                                    <td className="table__text--align">{index + 1}</td>
                                    <td className="table__text--align">
                                        <select className="select" id="itemId" name="itemId" value={item.itemId} onChange={(e) => handleCellChange(e, index)}>
                                            <option defaultValue="-1"></option>
                                            {itemList.map(item =>
                                                <option key={item.id} value={item.id}>{item.name}</option>
                                            )};
                                        </select>
                                    </td>
                                    <td className="table__text--align">
                                        <select className={item.itemTypeId === 25 && !item.item.toLowerCase().includes("sewer connect") ? "select" : "hidden"} id="frequencyId" name="frequencyId" value={item.frequencyId} onChange={(e) => handleCellChange(e, index)}>
                                            <option defaultValue="-1"></option>
                                            {frequencyList.map(item =>
                                                <option key={item.id} value={item.id}>{item.name}</option>
                                            )};
                                        </select>
                                    </td>
                                    <td className="table__text--align">
                                        <input type='number' min="0" step="0.01" className='form-control textalignright' id="oneWeek" name="oneWeek" value={item.oneWeek} onChange={(e) => handleCellChange(e, index)} />
                                    </td>
                                    <td className="table__text--align">
                                        <input type='number' min="0" step="0.01" className='form-control textalignright' id="sixWeek" name="sixWeek" value={item.sixWeek} onChange={(e) => handleCellChange(e, index)} />
                                    </td>
                                    <td className="table__text--align">
                                        <input type='number' min="0" step="0.01" className='form-control textalignright' id="tenWeek" name="tenWeek" value={item.tenWeek} onChange={(e) => handleCellChange(e, index)} />
                                    </td>
                                    <td className="table__text--align">
                                        <input type='number' min="0" step="0.01" className='form-control textalignright' id="thirteenWeek" name="thirteenWeek" value={item.thirteenWeek} onChange={(e) => handleCellChange(e, index)} />
                                    </td>
                                    <td className="table__text--align">
                                        <input type='number' min="0" step="0.01" className='form-control textalignright' id="fourteenWeek" name="fourteenWeek" value={item.fourteenWeek} onChange={(e) => handleCellChange(e, index)} />
                                    </td>
                                    <td className="table__text--align">
                                        <input type='number' min="0" step="0.01" className='form-control textalignright' id="twentyWeek" name="twentyWeek" value={item.twentyWeek} onChange={(e) => handleCellChange(e, index)} />
                                    </td>
                                    <td className="table__text--align">
                                        <input type='number' min="0" step="0.01" className='form-control textalignright' id="twentySixWeek" name="twentySixWeek" value={item.twentySixWeek} onChange={(e) => handleCellChange(e, index)} />
                                    </td>
                                    <td className="table__text--align">
                                        <input type='number' min="0" step="0.01" className='form-control textalignright' id="fortyWeek" name="fortyWeek" value={item.fortyWeek} onChange={(e) => handleCellChange(e, index)} />
                                    </td>
                                    <td className="table__text--align">
                                        <input type='number' min="0" step="0.01" className='form-control textalignright' id="fiftyTwoWeek" name="fiftyTwoWeek" value={item.fiftyTwoWeek} onChange={(e) => handleCellChange(e, index)} />
                                    </td>
                                    <td className="table__text--align">
                                        <input type='number' min="0" step="0.01" className='form-control textalignright' id="additionalHireWeeklyRate" name="additionalHireWeeklyRate" value={item.additionalHireWeeklyRate} onChange={(e) => handleCellChange(e, index)} />
                                    </td>
                                    <td className="table__text--align">
                                        <input type='number' min="0" step="0.01" className='form-control textalignright' id="travelOneWayRate" name="travelOneWayRate" value={item.travelOneWayRate} onChange={(e) => handleCellChange(e, index)} />
                                    </td>
                                    <td className="table__text--align">
                                        <div className={index === lastRow ? "hidden" : "delete--tablecell"}>
                                            <a className="makeitred" href="#" onClick={(e) => deleteItem(e, index)}>
                                                <span className="fas fa-times-circle edit--icon alignIconCenter"></span>
                                            </a>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        )}
                    </table>
                    {errors["pricelistitems"] ?
                        (errors["pricelistitems"]).split("\n").map((item: any, key: any) => {
                            return <span className="label errors" key={key}>{item}<br /></span>
                        })
                        : ""}
                </div>
            </div>
            <div className="colAlignRight marginBottom10">
                <button className={readOnly ? "hidden" : "defaultbutton defaultbutton__large"} type="button" onClick={save} disabled={priceListTier.priceListTierId < 0 || pricelistLoading ? true : false}>Save</button>
            </div>
        </div>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (
        <div>
            <h1>Price List Set Weeks</h1>
            {contents}
        </div>
    );
}

export default AdminPriceListSetWeeksData;